// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'b895f9c76af32afbc9d75e7de5d17afc2e4d4575';
export const BUILD_NUMBER = '209';
export const BUILD_TIMESTAMP = '2026-07-27T02:43:53.050Z';
